import { render, staticRenderFns } from "./CompanyFinancial.vue?vue&type=template&id=36017b4d&scoped=true&"
import script from "./CompanyFinancial.vue?vue&type=script&lang=js&"
export * from "./CompanyFinancial.vue?vue&type=script&lang=js&"
import style0 from "./CompanyFinancial.vue?vue&type=style&index=0&id=36017b4d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36017b4d",
  null
  
)

export default component.exports